<template>
  <div class="template">
    <q-form class="q-px-xl" ref="loginForm" @submit.prevent.stop="onSubmit">
      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">Usuario</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          type="text"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="30"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.username"
          :rules="[(val) => !!val.length || 'Campo Obrigatório']"
          lazy-rules
        />
      </div>
      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">nova senha</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          :type="isPwd ? 'password' : 'text'"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="10"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.password"
          :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
          lazy-rules
        >
          <template v-slot:append>
            <q-icon
              size="18px"
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
      </div>
      <div class="group-input col-12 row q-mt-sm">
        <label for="os_number">confirmar senha</label>
        <q-input
          id="os_number"
          ref="osNumberRef"
          :type="isPwdConfirm ? 'password' : 'text'"
          class="col-12 q-mt-sm"
          bg-color="white"
          maxlength="10"
          color="red-9"
          dense
          outlined
          unmasked-value
          v-model="auth.passwordConfirm"
          :rules="[
            (val) => val == auth.password || 'Senhas precisam ser iguais',
          ]"
          lazy-rules
        >
          <template v-slot:append>
            <q-icon
              size="18px"
              :name="isPwdConfirm ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwdConfirm = !isPwdConfirm"
            />
          </template>
        </q-input>
      </div>

      <div class="submit-btn col-12 row q-mt-sm">
        <div class="submit-btn col-md-12 flex justify-end section-btn">
          <q-btn
            class="submit-btn"
            unelevated
            no-caps
            :loading="btnLoading"
            size="md"
            type="submit"
            label="Mudar senha"
            rounded
            color="red-9"
          />
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
//-----VUEJS
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

//------UTILS
import { isUserTechnician } from "@/utils/auth/verifyUserLogged.js";
import technicianData from "@/constats.js";

//-----QUASAR
import { useQuasar } from "quasar";

//-----SERVICES
import ContingencyServices from "@/services/ContingencyServices";

export default {
  name: "ResetPassword",

  setup() {
    //----CONSTANTS
    const loginForm = ref(null);
    const $q = useQuasar();
    const router = useRouter();

    //----VARIABLES
    let auth = ref({
      username: "",
      password: "",
      passwordConfirm: "",
    });
    let btnLoading = ref(false);
    let isPwd = ref(true);
    let isPwdConfirm = ref(true);
    let contingencyServices = new ContingencyServices();

    async function onSubmit() {
      if (!(await loginForm.value.validate())) {
        $q.notify({
          color: "red-5",
          message: "Você precisa preencher todos os campos obrigatórios",
        });
        return;
      }
      btnLoading.value = true;

      let data = {
        username: auth.value.username,
        password: auth.value.password,
      };

      await contingencyServices
        .resetPassword(data)
        .then(async (response) => {
          btnLoading.value = false;
          $q.notify({
            message: "Senha atualizada com sucesso",
            color: "green-9",
            position: "top",
          });
          router.push({ name: "login" });
        })
        .catch((error) => {
          btnLoading.value = false;
          $q.notify({
            message: error.toString(),
            color: "red-9",
            position: "top",
          });
        });
    }

    return {
      //----VARIABLES
      loginForm,
      auth,
      btnLoading,
      isPwd,
      isPwdConfirm,

      //FUNCTIONS
      onSubmit,
    };
  },
};
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #e5e5e5;

  label {
    color: rgba(0, 0, 0, 0.4);
    font-size: 0.875rem;
    font-family: Roboto;
    font-weight: 700;
  }
}

.submit-btn {
  width: 100%;
  display: flex;
}

.footer {
  a {
    font-size: 0.75rem;
    color: #868686;
    text-decoration: none;

    span {
      color: #c62828;
    }
  }
}
</style>
